
import { Card, Col, Row } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'
import { useMaterias } from '../../hooks/adminexamen/useMaterias'

const Materias = () => {

    const { materias } = useMaterias()

    return (
        <>
            <Row gutter={16}>
                { materias.map( (e, i) => (
                    <Col xs={ 24 } md={ 12 } lg={ 8 } xl={ 6 } key={ i } style={{ marginBottom: 10 }}>
                        <Link to={ '/materias/'+e.pk_materia }>
                            <Card
                                title={ e.materia }
                                hoverable
                            >
                                { e.cantidad } preguntas
                            </Card>
                        </Link>
                    </Col>
                )) }
            </Row>
        </>
    )
}

export default Materias
